<div class="container">
  <div class="card flex-auto">
    <div class="px-6 py-4 border-b flex items-center header-title">
      <h2 class="title m-0" *ngIf="item">{{"ADDONS_LIST.EDIT_ADDON" | translate}}</h2>
      <h2 class="title m-0" *ngIf="!item">{{"ADDONS_LIST.NEW_ADDON" | translate}}</h2>
      <div class="flex-end">
        <button [matMenuTriggerFor]="languageFormMenu" mat-icon-button type="button" align="end">
          <mat-icon svgIcon="{{iconFormFlag}}"></mat-icon>
        </button>
        <mat-menu #languageFormMenu="matMenu" overlapTrigger="false">
          <button mat-menu-item (click)="changeFormLanguage('it')">
            <mat-icon svgIcon="flag:italy"></mat-icon>
            <span>Italiano</span>
          </button>
          <button mat-menu-item (click)="changeFormLanguage('en')">
            <mat-icon svgIcon="flag:united-states"></mat-icon>
            <span>English</span>
          </button>
        </mat-menu>
      </div>
    </div>

    <div class="px-6 py-4 flex flex-col">

      <div class="card px-6 py-4 flex flex-col subCards">
        <div class="flex flex-col sm:flex-row sm:gap-4">
          <mat-form-field class="flex-auto" *ngIf="formLang=='it'">
            <mat-label>{{"ADDONS_LIST.NAME" | translate}} {{"GLOBAL.ITA" | translate}}</mat-label>
            <input matInput [(ngModel)]="ngForm.i18nName['IT']" required>
          </mat-form-field>

          <mat-form-field class="flex-auto" *ngIf="formLang=='en'">
            <mat-label>{{"ADDONS_LIST.NAME" | translate}} {{"GLOBAL.ENG" | translate}}</mat-label>
            <input matInput [(ngModel)]="ngForm.i18nName['EN']" required>
          </mat-form-field>

          <mat-form-field class="flex-auto">
            <mat-label>{{"ADDONS_LIST.CATEGORY" | translate}} </mat-label>
            <mat-select [(ngModel)]="ngForm.category" required>
              <mat-option [value]="item.key" *ngFor="let item of categories">{{item.value}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div>
          <p>{{"ADDONS_LIST.VALIDATION_DATE" | translate}} ({{"ADDONS_LIST.FROM" | translate}})</p>
          <div class="flex flex-col sm:flex-row sm:gap-4">
            <mat-form-field class="flex-auto">
              <mat-label>Giorno</mat-label>
              <input matInput type="number" [(ngModel)]="validationDate.from.day" name="day" min="1" max="31"
                required />
            </mat-form-field>

            <mat-form-field class="flex-auto">
              <mat-label>Mese</mat-label>
              <input matInput type="number" [(ngModel)]="validationDate.from.month" name="month" min="1" max="12"
                required />
            </mat-form-field>

            <mat-form-field class="flex-auto">
              <mat-label>Anno</mat-label>
              <input matInput type="number" [(ngModel)]="validationDate.from.year" name="year" min="1900" required />
            </mat-form-field>
          </div>
        </div>
        <div>
          <p>{{"ADDONS_LIST.VALIDATION_DATE" | translate}} ({{"ADDONS_LIST.TO" | translate}})</p>
          <div class="flex flex-col sm:flex-row sm:gap-4">
            <mat-form-field class="flex-auto">
              <mat-label>Giorno</mat-label>
              <input matInput type="number" [(ngModel)]="validationDate.to.day" name="day" min="1" max="31" required />
            </mat-form-field>

            <mat-form-field class="flex-auto">
              <mat-label>Mese</mat-label>
              <input matInput type="number" [(ngModel)]="validationDate.to.month" name="month" min="1" max="12"
                required />
            </mat-form-field>

            <mat-form-field class="flex-auto">
              <mat-label>Anno</mat-label>
              <input matInput type="number" [(ngModel)]="validationDate.to.year" name="year" min="1900" required />
            </mat-form-field>
          </div>
        </div>

        <div class="flex flex-col sm:flex-row sm:gap-4">

          <mat-form-field class="flex-auto">
              <mat-label>{{"ADDONS_LIST.PLANS" | translate }}</mat-label>
              <mat-select [(ngModel)]="ngForm.planAllowed" multiple  required>
                <mat-option [value]="item.id" *ngFor="let item of subs">{{item.type + ' ' + ("GENERIC."+item.duration | translate)}}</mat-option>
              </mat-select>
          </mat-form-field>

          <mat-form-field class="flex-auto">
            <mat-label>Img Url</mat-label>
            <input matInput [(ngModel)]="ngForm.imgUrl" required>
          </mat-form-field>

        </div>

        <div class="flex flex-col sm:flex-row sm:gap-4">

          <mat-form-field class="flex-auto">
            <mat-label>{{ "ADDONS_LIST.PRICE" | translate }}</mat-label>
            <input matInput type="text" [(ngModel)]="ngForm.price" required>
          </mat-form-field>

          <mat-form-field class="flex-auto">
            <mat-label>{{ "ADDONS_LIST.CURRENCY" | translate }}</mat-label>
            <input matInput type="text" [(ngModel)]="ngForm.currency" required>
          </mat-form-field>

          <mat-form-field class="flex-auto">
            <mat-label>{{ "ADDONS_LIST.ITEM_PRICE_ID" | translate }}</mat-label>
            <input matInput type="text" [(ngModel)]="ngForm.itemPriceId" required>
          </mat-form-field>
        </div>

        <div class="flex flex-col sm:flex-row sm:gap-4">
          <mat-form-field class="flex-auto" *ngIf="formLang=='it'">
            <mat-label>{{"ADDONS_LIST.DESCRIPTION" | translate}} {{"GLOBAL.ITA" | translate}}</mat-label>
            <textarea matInput [(ngModel)]="ngForm.i18nDescription['IT']" required></textarea>
          </mat-form-field>

          <mat-form-field class="flex-auto" *ngIf="formLang=='en'">
            <mat-label>{{"ADDONS_LIST.DESCRIPTION" | translate}} {{"GLOBAL.ENG" | translate}}</mat-label>
            <textarea matInput [(ngModel)]="ngForm.i18nDescription['EN']" required></textarea>
          </mat-form-field>
        </div>

        <div class="bottoni">
          <button (click)="confirmClose()" class="m-4">{{"GLOBAL.CLOSE" | translate}}</button>
          <button mat-raised-button [disabled]="isFormInvalid()" (click)="submit()" class="m-4 bottone-viola" *ngIf="item">{{"GLOBAL.EDIT" | translate}}</button>
          <button mat-raised-button [disabled]="isFormInvalid()" (click)="submit()" class="m-4 bottone-viola" *ngIf="!item">{{"GLOBAL.CREATE" | translate}}</button>
        </div>
      </div>
    </div>
  </div>
